import { render, staticRenderFns } from "./BaoCaoGeneric.vue?vue&type=template&id=5e673f3a&scoped=true"
import script from "./BaoCaoGeneric.vue?vue&type=script&lang=ts"
export * from "./BaoCaoGeneric.vue?vue&type=script&lang=ts"
import style0 from "./BaoCaoGeneric.vue?vue&type=style&index=0&id=5e673f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e673f3a",
  null
  
)

export default component.exports